export const DIVIDER_ORIENTATION_HORIZONTAL = 'horizontal' as const;
export const DIVIDER_ORIENTATION_VERTICAL = 'vertical' as const;

export type DividerOrientation =
  | typeof DIVIDER_ORIENTATION_HORIZONTAL
  | typeof DIVIDER_ORIENTATION_VERTICAL;
